import { Button, Stack, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import API from '../../services/API'

const Impersonate = ({ tenantId, subdomain, userId }) => {
  const [reason, setReason] = useState('')

  const handleSubmit = (e) => {
    e.preventDefault()
    API.post('/admin/impersonate', {
      tenantId,
      reason,
      subdomain,
      userId,
    }).then((res) => {
      if (res.status === 200) {
        window.open(`https://${res.data}`)
      }
    })
  }
  return (
    <Stack gap={1} component="form" onSubmit={handleSubmit}>
      <Typography variant="title2" fontSize="1rem">
        Enter the reason for accessing this tenant below
      </Typography>
      <TextField
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        fullWidth
      />
      <Button type="submit" variant="contained" color="anBlue" fullWidth>
        Submit
      </Button>
    </Stack>
  )
}

export default Impersonate
